export function Marquee({ items }) {
    const List = ({ hidden }) => (
        <div
            className="flex w-max shrink-0 items-center"
            aria-hidden={hidden || undefined}
        >
            {items.map((it, i) => (
                <span key={i} className="flex items-center">
                    <span className="whitespace-nowrap px-10 font-mono text-xs uppercase tracking-[0.35em] text-paper/70">
                        {it}
                    </span>
                    <svg viewBox="0 0 24 24" className="h-3 w-3 text-sky" aria-hidden="true">
                        <path d="M13 2 4 14h6l-1 8 9-12h-6l1-8z" fill="currentColor" />
                    </svg>
                </span>
            ))}
        </div>
    );
    return (
        <div
            className="overflow-hidden bg-ink py-6"
            data-testid="editorial-marquee"
        >
            <div className="flex w-max animate-marquee">
                <List />
                <List hidden />
            </div>
        </div>
    );
}
